import { render, staticRenderFns } from "./JSKUList.vue?vue&type=template&id=acdd6a46"
import script from "./JSKUList.vue?vue&type=script&lang=js"
export * from "./JSKUList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports